/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface UpgradeYourFleetImageUrls
 */
export interface UpgradeYourFleetImageUrls {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof UpgradeYourFleetImageUrls
   */
  imageUrlByLanguageIso: { [key: string]: string }
}

/**
 * Check if a given object implements the UpgradeYourFleetImageUrls interface.
 */
export function instanceOfUpgradeYourFleetImageUrls(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'imageUrlByLanguageIso' in value

  return isInstance
}

export function UpgradeYourFleetImageUrlsFromJSON(
  json: any,
): UpgradeYourFleetImageUrls {
  return UpgradeYourFleetImageUrlsFromJSONTyped(json, false)
}

export function UpgradeYourFleetImageUrlsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpgradeYourFleetImageUrls {
  if (json === undefined || json === null) {
    return json
  }
  return {
    imageUrlByLanguageIso: json['imageUrlByLanguageIso'],
  }
}

export function UpgradeYourFleetImageUrlsToJSON(
  value?: UpgradeYourFleetImageUrls | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    imageUrlByLanguageIso: value.imageUrlByLanguageIso,
  }
}
